/* ss-savings-meter — keeps every .ss-sm on the page in sync with the selected variant, quantity and cart.
   Free shipping counts the whole cart. The percent-off tiers count only products that are NOT in the excluded
   collections (new arrivals / weekly deals / clearance). This is a display only; Shopify discounts do the real work. */
(function () {
  if (window.__ssSavingsMeter) return;
  window.__ssSavingsMeter = true;

  var meters = [];
  var cartItems = null;      // from /cart.js after the first cart change
  var excludedSet = null;    // product ids in the excluded collections (loaded once, cached)
  var lastAdd = null;        // "variantId|qty" just added, so it is not counted twice
  var timer = null;

  function money(cents, sym) {
    var d = cents / 100;
    return sym + (Math.abs(d - Math.round(d)) < 0.005 ? String(Math.round(d)) : d.toFixed(2));
  }

  /* ---------- excluded collections (live, cached for 30 min) ---------- */
  function loadExcluded(handles) {
    if (!handles.length || excludedSet) return;
    var KEY = 'ss-sm-excluded:' + handles.join('+');
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && Date.now() - c.t < 30 * 60 * 1000) { excludedSet = new Set(c.ids); return; }
    } catch (e) {}
    var ids = [];
    function page(handle, n) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + n, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) {
          var list = (j && j.products) || [];
          list.forEach(function (p) { ids.push(p.id); });
          return list.length === 250 && n < 8 ? page(handle, n + 1) : null;
        })
        .catch(function () { return null; });
    }
    Promise.all(handles.map(function (h) { return page(h, 1); })).then(function () {
      excludedSet = new Set(ids);
      try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), ids: ids })); } catch (e) {}
      updateAll(true);
    });
  }

  function Meter(root) {
    this.root = root;
    this.sym = root.getAttribute('data-symbol') || '$';
    this.initAll = parseInt(root.getAttribute('data-cart-all'), 10) || 0;
    this.initElig = parseInt(root.getAttribute('data-cart-elig'), 10) || 0;
    this.pid = root.getAttribute('data-product-id');
    this.pageExcluded = root.getAttribute('data-excluded') === '1';
    this.variantFallback = root.getAttribute('data-variant');
    this.known = {};   // product id -> excluded? (from the server-rendered cart lines)
    (root.getAttribute('data-lines') || '').split(',').forEach(function (l) {
      var p = l.split(':'); if (p[0]) this.known[p[0]] = p[1] === '1';
    }, this);
    this.known[this.pid] = this.pageExcluded;
    this.excludedHandles = (root.getAttribute('data-excluded-collections') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    this.initHasExcluded = root.getAttribute('data-cart-has-excluded') === '1';
    this.tiers = (root.getAttribute('data-tiers') || '').split(',').map(function (t) {
      var p = t.split('|');
      return { at: Math.round(parseFloat(p[0]) * 100), label: (p[1] || '').trim(), rate: parseFloat(p[2] || '0') / 100, scope: (p[3] || 'all').trim() };
    }).filter(function (t) { return t.at > 0; });
    // restricted product: the meter stops at free shipping (percent-off tiers are not shown)
    if (this.pageExcluded) this.tiers = this.tiers.filter(function (t) { return t.scope !== 'eligible'; });
    this.variants = {};
    (root.getAttribute('data-variants') || '').split(',').forEach(function (v) {
      var p = v.split(':');
      if (p[0]) this.variants[p[0]] = { price: parseInt(p[1], 10), available: p[2] === 'true' };
    }, this);
    this.msg = root.querySelector('.ss-sm__msg');
    this.fill = root.querySelector('.ss-sm__fill');
    this.dots = root.querySelectorAll('.ss-sm__dot');
    this.labels = root.querySelectorAll('.ss-sm__label');
    this.note = root.querySelector('.ss-sm__note');
    this.save = root.querySelector('.ss-sm__save');
    this.chip = root.querySelector('.ss-sm__chip');
    this.saveText = root.querySelector('.ss-sm__save-text');
    this.sig = '';
    this.wasComplete = false;
    var self = this;
    root.addEventListener('animationend', function () { self.root.classList.remove('is-celebrate'); });
    this.isExcluded = function (pid) {
      pid = String(pid);
      if (excludedSet) return excludedSet.has(Number(pid)) || excludedSet.has(pid);
      return this.known[pid] === true;
    };
  }

  Meter.prototype.read = function () {
    var form = document.querySelector('form[action*="/cart/add"]');
    var idEl = form && form.querySelector('[name="id"]');
    var qtyEl = form && form.querySelector('[name="quantity"]');
    var id = (idEl && idEl.value) || this.variantFallback;
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    return { id: String(id), qty: qty };
  };

  Meter.prototype.cartTotals = function () {
    if (!cartItems) return { all: this.initAll, elig: this.initElig, hasEx: this.initHasExcluded };
    var all = 0, elig = 0, hasEx = false, self = this;
    cartItems.forEach(function (it) {
      all += it.original_line_price;
      if (self.isExcluded(it.product_id)) hasEx = true; else elig += it.original_line_price;
    });
    return { all: all, elig: elig, hasEx: hasEx };
  };

  Meter.prototype.update = function (force) {
    var sel = this.read();
    var v = this.variants[sel.id];
    var cart = this.cartTotals();
    var key = sel.id + '|' + sel.qty;
    var add = (lastAdd === key || !v) ? 0 : v.price * sel.qty;
    var sig = [sel.id, sel.qty, cart.all, cart.elig, add, excludedSet ? 1 : 0].join('|');
    if (!force && sig === this.sig) return;
    this.sig = sig;

    if (!v || !v.available) { this.root.hidden = true; return; }
    this.root.hidden = false;

    var all = cart.all + add;
    var elig = cart.elig + (this.pageExcluded ? 0 : add);
    var hasEx = cart.hasEx || this.pageExcluded;
    var tiers = this.tiers, i;
    function valueOf(t) { return t.scope === 'eligible' ? elig : all; }

    var cur = null, next = null, nextIdx = -1;
    for (i = 0; i < tiers.length; i++) {
      if (valueOf(tiers[i]) >= tiers[i].at) { if (!next) cur = tiers[i]; }
      else if (!next) { next = tiers[i]; nextIdx = i; }
    }
    var complete = !next && !!cur;

    var text;
    if (complete) {
      var custom = this.root.getAttribute('data-top');
      text = this.pageExcluded ? (cur.label + ' unlocked') : custom || ('You’ve unlocked our best deal' + (cur.rate > 0 ? ': ' + Math.round(cur.rate * 100) + '% off + free shipping' : ''));
    } else {
      var gap = money(next.at - valueOf(next), this.sym);
      var more = (next.scope === 'eligible' && hasEx) ? ' of regular-price items' : '';
      if (!cur) text = 'You are ' + gap + ' away from ' + next.label.toLowerCase();
      else text = cur.label + ' unlocked. Add ' + gap + ' more' + more + ' for ' + next.label.toLowerCase();
    }
    this.msg.textContent = text;
    this.root.classList.toggle('is-complete', complete);
    if (complete && !this.wasComplete) {
      this.root.classList.remove('is-celebrate');
      void this.root.offsetWidth;
      this.root.classList.add('is-celebrate');
    }
    this.wasComplete = complete;

    // bar position: piecewise between ticks so it never jumps backwards
    var scale = this.pageExcluded ? Math.round(tiers[tiers.length - 1].at * 1.176) : Math.max(10000, Math.round(tiers[tiers.length - 1].at * 1.176));
    var pos;
    if (complete) pos = scale;
    else {
      var prevAt = nextIdx > 0 ? tiers[nextIdx - 1].at : 0;
      var prog = Math.max(0, Math.min(1, (valueOf(next) - prevAt) / (next.at - prevAt)));
      pos = prevAt + prog * (next.at - prevAt);
    }
    this.fill.style.width = Math.min(100, (pos / scale) * 100) + '%';
    for (i = 0; i < tiers.length; i++) {
      var on = valueOf(tiers[i]) >= tiers[i].at;
      if (this.dots[i]) this.dots[i].classList.toggle('is-on', on);
      if (this.labels[i]) this.labels[i].classList.toggle('is-on', on);
    }

    if (this.note) {
      this.note.hidden = !hasEx;
      this.note.textContent = this.pageExcluded
        ? 'This item is already specially priced, so it doesn\u2019t count toward 20% / 30% off. Free shipping still applies.'
        : 'Specially priced items in your cart count toward free shipping only, not 20% / 30% off.';
    }

    var rate = 0;
    for (i = 0; i < tiers.length; i++) { if (tiers[i].rate > 0 && valueOf(tiers[i]) >= tiers[i].at && tiers[i].rate > rate) rate = tiers[i].rate; }
    if (rate > 0 && this.save) {
      var disc = Math.round(elig * rate);
      this.chip.textContent = 'Saving ' + money(disc, this.sym);
      this.saveText.textContent = Math.round(rate * 100) + '% off applied' + (hasEx ? ' to eligible items' : '') + ' · you pay ' + money(all - disc, this.sym);
      this.save.hidden = false;
    } else if (this.save) {
      this.save.hidden = true;
    }
  };

  function updateAll(force) { meters.forEach(function (m) { m.update(force); }); }

  function refetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartItems = c.items || []; updateAll(true); })
      .catch(function () {});
  }

  function onCartMutation(isAdd) {
    if (isAdd && meters[0]) { var s = meters[0].read(); lastAdd = s.id + '|' + s.qty; }
    refetchCart();
  }

  var CART_RE = /\/cart\/(add|change|update|clear)/;
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var a = arguments[0];
      var url = typeof a === 'string' ? a : (a && a.url) || '';
      var p = origFetch.apply(this, arguments);
      if (CART_RE.test(url)) {
        var isAdd = /\/cart\/add/.test(url);
        p.then(function () { onCartMutation(isAdd); }, function () {});
      }
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      var u = String(url || '');
      if (CART_RE.test(u)) {
        var isAdd = /\/cart\/add/.test(u);
        this.addEventListener('load', function () { onCartMutation(isAdd); });
      }
      return origOpen.apply(this, arguments);
    };
  }
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:added'].forEach(function (ev) {
    document.addEventListener(ev, function () { refetchCart(); });
  });

  function init() {
    var nodes = document.querySelectorAll('.ss-sm');
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].__ss) { nodes[i].__ss = true; meters.push(new Meter(nodes[i])); }
    }
    if (meters.length) loadExcluded(meters[0].excludedHandles);
    updateAll(true);
    if (!timer && meters.length) timer = setInterval(function () { updateAll(false); }, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();